import moment from 'moment'

export const DATE_FORMAT_FULL_DAY = 'MMMM D, YYYY'

export default (date: string | Date, format: string = DATE_FORMAT_FULL_DAY): string =>
  moment(date).format(format)
